import { Injectable } from '@angular/core';
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { XrefLibFeatureFlagService } from '@xref/xref-lib';
import { IdService} from "../id/id.service";


@Injectable({
    providedIn: 'root'
})
export class PermissionsService {
    activeFeatureFlags = [] as any;
    activeDomainList = [] as any;

    constructor(
        private idService: IdService,
        private featureFlagService: XrefLibFeatureFlagService
    ) { }


    initService() {
        return this.getActiveFeatureFlags();
    }

    getActiveFeatureFlags() {
        return this.idService.getActiveFlags().pipe(map(res => {
            this.activeFeatureFlags = res['data'].feature_flags;
            this.activeDomainList = res['data'].domain_list;
            this.featureFlagService.initializeFlags(this.activeFeatureFlags);
        }), catchError(err => of(err) ));
    }

    isFeatureActivated(feature: string): boolean {
        return this.activeFeatureFlags.indexOf(feature) > -1;
    }

    isDomainActivated(domain: string): boolean {
        return this.activeDomainList.indexOf(domain) > -1;
    }
}
